import { render, staticRenderFns } from "./BaseCardTab.vue?vue&type=template&id=5656c592&scoped=true&"
import script from "./BaseCardTab.vue?vue&type=script&lang=js&"
export * from "./BaseCardTab.vue?vue&type=script&lang=js&"
import style0 from "./BaseCardTab.vue?vue&type=style&index=0&id=5656c592&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5656c592",
  null
  
)

export default component.exports